import { render, staticRenderFns } from "./Netherlands.vue?vue&type=template&id=01ca03b4"
import script from "./Netherlands.vue?vue&type=script&lang=js"
export * from "./Netherlands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports